var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2643",
    "data-name": "Rectangle 2643",
    width: 16,
    height: 16,
    transform: "translate(39 143)",
    fill: "#8391a2",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_331",
    "data-name": "Mask Group 331",
    transform: "translate(-39 -143)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_7_",
    "data-name": "svgexport-6 (7)",
    transform: "translate(39.001 143)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8198",
    "data-name": "Path 8198",
    d: "M15.583,6.959h0L9.055.431a1.473,1.473,0,0,0-2.083,0L.449,6.955l-.007.007a1.472,1.472,0,0,0,.98,2.51l.046,0h.26v4.8A1.726,1.726,0,0,0,3.452,16H6.006a.469.469,0,0,0,.469-.469V11.766a.787.787,0,0,1,.787-.787H8.767a.787.787,0,0,1,.787.787v3.766a.469.469,0,0,0,.469.469h2.553A1.726,1.726,0,0,0,14.3,14.276v-4.8h.241a1.473,1.473,0,0,0,1.042-2.514ZM14.92,8.379a.532.532,0,0,1-.379.157h-.71A.469.469,0,0,0,13.362,9v5.272a.787.787,0,0,1-.786.786H10.491v-3.3a1.726,1.726,0,0,0-1.724-1.724H7.261a1.726,1.726,0,0,0-1.724,1.724v3.3H3.452a.787.787,0,0,1-.787-.786V9A.469.469,0,0,0,2.2,8.536h-.72a.535.535,0,0,1-.369-.913h0L7.635,1.094a.535.535,0,0,1,.757,0l6.525,6.525,0,0a.537.537,0,0,1,0,.756Zm0,0",
    transform: "translate(-0.015 0)",
    fill: "#8391a2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.dc0562a324b5e8f752e6d3f7839e79a7.svg";
export { ForwardRef as ReactComponent };